module.exports = __webpack_public_path__ + "img/close.40f0397b.svg";